import IcTransport from './IcTransport'
export default IcTransport
